// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";

// import ProctorPanel from "./components/ProctorPanel";
// import QuestionRenderer from "./components/QuestionRenderer";
// import QuestionPalette from "./components/QuestionPalette";
// import ExamFooter from "./components/ExamFooter";
// import TimerBar from "./components/TimerBar";
// import SectionTabs from "./components/SectionTabs";
// import { ViolationProvider } from "./components/ViolationContext";
// import api from "../../../api/axiosInstance";

// const SECTION_CONFIG = {
//   aptitude: { label: "APTITUDE", count: 10, time: 600 },
//   technical: { label: "TECHNICAL", count: 10, time: 900 },
//   coding: { label: "CODING", count: 1, time: 900 },
// };

// const SECTION_ORDER = ["aptitude", "technical", "coding"];

// export default function MockTestEngine() {
//   const navigate = useNavigate();

//   const [section, setSection] = useState("aptitude");
//   const [completedSection, setCompletedSection] = useState("aptitude");

//   const [questions, setQuestions] = useState([]);
//   const [index, setIndex] = useState(0);
//   const [answers, setAnswers] = useState({});
//   const [review, setReview] = useState({});
//   const [loading, setLoading] = useState(true);

//   /* ================= FETCH QUESTIONS PER SECTION ================= */
//   useEffect(() => {
//     setLoading(true);
//     setIndex(0);

//     fetch(
//       `${API}/questions/random?category=${section}&count=${SECTION_CONFIG[section].count}`
//     )
//       .then((res) => res.json())
//       .then((data) => {
//         setQuestions(Array.isArray(data) ? data : []);
//         setLoading(false);
//       })
//       .catch(() => setLoading(false));
//   }, [section]);

//   const autoSubmit = () => {
//     navigate("/candidate/mock-test/result", { replace: true });
//   };

//   if (loading) {
//     return (
//       <div className="h-screen flex items-center justify-center text-lg font-medium">
//         Loading {SECTION_CONFIG[section].label} questions…
//       </div>
//     );
//   }

//   if (questions.length === 0) {
//     return (
//       <div className="h-screen flex items-center justify-center text-red-600">
//         No questions available for {SECTION_CONFIG[section].label}
//       </div>
//     );
//   }

//   const question = questions[index];

//   const goNext = () => {
//     if (index < questions.length - 1) {
//       setIndex(index + 1);
//     } else {
//       const nextSectionIndex = SECTION_ORDER.indexOf(section) + 1;

//       if (nextSectionIndex < SECTION_ORDER.length) {
//         const nextSection = SECTION_ORDER[nextSectionIndex];
//         setCompletedSection(nextSection);
//         setSection(nextSection);
//       } else {
//         autoSubmit();
//       }
//     }
//   };

//   return (
//     <ViolationProvider onAutoSubmit={autoSubmit}>
//       <div className="flex h-screen">

//         {/* LEFT – PROCTOR */}
//         <ProctorPanel />

//         {/* CENTER */}
//         <div className="flex-1 flex flex-col bg-slate-50">
//           <TimerBar
//             duration={SECTION_CONFIG[section].time}
//             onTimeUp={goNext}
//           />

//           <div className="p-8 flex-1 overflow-auto">
//             <SectionTabs
//               active={section}
//               completed={completedSection}
//               onSwitch={() => {}}
//             />

//             <p className="text-sm text-gray-500 mb-2">
//               {SECTION_CONFIG[section].label} · Question {index + 1}/{questions.length}
//             </p>

//             <QuestionRenderer
//               question={question}
//               selected={answers[`${section}-${index}`]}
//               onSelect={(opt) =>
//                 setAnswers({
//                   ...answers,
//                   [`${section}-${index}`]: opt,
//                 })
//               }
//             />
//           </div>

//           <ExamFooter
//             canGoBack={index > 0}
//             onBack={() => setIndex(index - 1)}
//             onReview={() =>
//               setReview({
//                 ...review,
//                 [`${section}-${index}`]: true,
//               })
//             }
//             onNext={goNext}
//           />
//         </div>

//         {/* RIGHT – PALETTE */}
//         <QuestionPalette
//           total={questions.length}
//           current={index}
//           answers={answers}
//           review={review}
//           onJump={setIndex}
//         />
//       </div>
//     </ViolationProvider>
//   );
// }
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import ProctorPanel from "./components/ProctorPanel";
import QuestionRenderer from "./components/QuestionRenderer";
import QuestionPalette from "./components/QuestionPalette";
import ExamFooter from "./components/ExamFooter";
import TimerBar from "./components/TimerBar";
import SectionTabs from "./components/SectionTabs";
import { ViolationProvider } from "./components/ViolationContext";
import api from "../../../api/axiosInstance";

const SECTION_CONFIG = {
  aptitude: { label: "APTITUDE", count: 10, time: 600 },
  technical: { label: "TECHNICAL", count: 10, time: 900 },
  coding: { label: "CODING", count: 5, time: 900 },
};

const SECTION_ORDER = ["aptitude", "technical", "coding"];

export default function MockTestEngine() {
  const navigate = useNavigate();

  const [section, setSection] = useState("aptitude");
  const [completedSection, setCompletedSection] = useState("aptitude");

  const [questions, setQuestions] = useState([]);
  const [index, setIndex] = useState(0);
  const [answers, setAnswers] = useState({});
  const [review, setReview] = useState({});
  const [loading, setLoading] = useState(true);
  const [codeAnswers, setCodeAnswers] = useState({});
  const [testSessionId, setTestSessionId] = useState(null);
  const [allSectionAnswers, setAllSectionAnswers] = useState({});
  const [allSectionQuestions, setAllSectionQuestions] = useState({});

  /* ================= CHECK ANSWER CORRECTNESS ================= */
  const checkAnswerCorrectness = (userAnswer, question) => {
    // Validate inputs
    if (!userAnswer || !question) return false;
    
    // For multiple choice questions
    if (question.correctOption && Array.isArray(question.options)) {
      const optionIndexMap = { A: 0, B: 1, C: 2, D: 3 };
      const correctAnswer = question.options[optionIndexMap[question.correctOption]];
      return userAnswer === correctAnswer;
    }
    
    // For coding questions (any non-empty answer gets points)
    if (question.category === 'coding') {
      return userAnswer.trim().length > 0;
    }
    
    // Default case - assume incorrect
    return false;
  };

  /* ================= SAVE ANSWER TO DATABASE ================= */
  const saveAnswerToDatabase = async (question, userAnswer, correctAnswer) => {
    try {
      const userStr = localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : null;
      
      if (!user || !user.email) return;

      const answerData = {
        userId: user.email,
        question: question.questionText || question.question,
        userAnswer: userAnswer,
        correctAnswer: correctAnswer,
        topic: question.topic || section,
        score: userAnswer === correctAnswer ? 10 : 0
      };

      await api.post('/api/mock-test/answer', answerData);
    } catch (error) {
      console.error('Error saving answer:', error);
    }
  };

  /* ================= COMPLETE TEST AND CALCULATE SCORE ================= */
  const completeTestAndCalculateScore = async () => {
    try {
      const userStr = localStorage.getItem('user');
      const user = userStr ? JSON.parse(userStr) : null;
      
      if (!user || !user.email) return;

      // Save final section answers and questions
      const finalSectionAnswers = {
        ...allSectionAnswers,
        [section]: { ...answers, ...codeAnswers }
      };

      const finalSectionQuestions = {
        ...allSectionQuestions,
        [section]: [...questions]
      };

      // Collect all answers from all sections with correct validation
      const allAnswers = [];
      
      // Process each section's answers
      Object.entries(finalSectionAnswers).forEach(([sectionName, sectionAnswers]) => {
        const sectionQuestions = finalSectionQuestions[sectionName] || [];
        
        Object.entries(sectionAnswers).forEach(([key, userAnswer]) => {
          const [answerSection, questionIndex] = key.split('-');
          const questionNum = parseInt(questionIndex);
          
          // Validate question index
          if (isNaN(questionNum) || questionNum < 0) return;
          
          const question = sectionQuestions[questionNum];
          if (!question) return;
          
          // Only process answered questions
          if (userAnswer && userAnswer.trim().length > 0) {
            // Check if answer is correct
            const isCorrect = checkAnswerCorrectness(userAnswer, question);
            
            allAnswers.push({
              question: question.questionText || question.question || `Question ${questionNum + 1} from ${sectionName}`,
              userAnswer: userAnswer,
              correctAnswer: question.correctOption || 'Code submission',
              topic: sectionName,
              score: isCorrect ? 10 : 0
            });
          }
        });
      });

      // Submit all answers
      const testData = {
        userId: user.email,
        answers: allAnswers,
        isCompleted: true,
        endedAt: new Date()
      };

      await api.post('/api/mock-test/complete', testData);
      
    } catch (error) {
      console.error('Error completing test:', error);
    }
  };

  /* ================= FETCH QUESTIONS PER SECTION ================= */
  useEffect(() => {
    let isMounted = true;
    setLoading(true);
    setIndex(0);

    const fetchQuestions = async () => {
      try {
        const res = await api.get("/api/questiondatabase/random", {
          params: {
            category: section,
            count: SECTION_CONFIG[section].count,
          },
        });

        if (isMounted) {
          setQuestions(Array.isArray(res.data) ? res.data : []);
        }
      } catch (error) {
        console.error("Failed to load questions:", error);
        if (isMounted) setQuestions([]);
      } finally {
        if (isMounted) setLoading(false);
      }
    };

    fetchQuestions();

    return () => {
      isMounted = false;
    };
  }, [section]);

  const autoSubmit = async () => {
    await completeTestAndCalculateScore();
    navigate("/candidate/mock-test/completed", { replace: true });
  };

  if (loading) {
    return (
      <div className="h-screen flex items-center justify-center text-lg font-medium">
        Loading {SECTION_CONFIG[section].label} questions…
      </div>
    );
  }

  if (questions.length === 0) {
    return (
      <div className="h-screen flex items-center justify-center text-red-600">
        No questions available for {SECTION_CONFIG[section].label}
      </div>
    );
  }

  const question = questions[index];

  const handleCodeSubmit = (code) => {
    setCodeAnswers({
      ...codeAnswers,
      [`${section}-${index}`]: code,
    });
    goNext();
  };

  const goNext = () => {
    if (index < questions.length - 1) {
      setIndex(index + 1);
    } else {
      // Save current section answers and questions before moving to next section
      const currentSectionAnswers = {
        ...allSectionAnswers,
        [section]: { ...answers, ...codeAnswers }
      };
      setAllSectionAnswers(currentSectionAnswers);

      // Also save the questions from this section
      const currentSectionQuestions = {
        ...allSectionQuestions,
        [section]: [...questions]
      };
      setAllSectionQuestions(currentSectionQuestions);

      const nextSectionIndex = SECTION_ORDER.indexOf(section) + 1;

      if (nextSectionIndex < SECTION_ORDER.length) {
        const nextSection = SECTION_ORDER[nextSectionIndex];
        setCompletedSection(nextSection);
        setSection(nextSection);
        // Clear current answers for new section
        setAnswers({});
        setCodeAnswers({});
      } else {
        autoSubmit();
      }
    }
  };

  return (
    <ViolationProvider onAutoSubmit={autoSubmit}>
      <div className="flex h-screen">

        {/* LEFT – PROCTOR */}
        <ProctorPanel />

        {/* CENTER */}
        <div className="flex-1 flex flex-col bg-slate-50">
          <TimerBar
            duration={SECTION_CONFIG[section].time}
            onTimeUp={goNext}
          />

          <div className="p-8 flex-1 overflow-auto">
            <SectionTabs
              active={section}
              completed={completedSection}
              onSwitch={() => {}}
            />

            <p className="text-sm text-gray-500 mb-2">
              {SECTION_CONFIG[section].label} · Question {index + 1}/{questions.length}
            </p>

            <QuestionRenderer
              question={question}
              selected={answers[`${section}-${index}`]}
              onSelect={(opt) => {
                const answerKey = `${section}-${index}`;
                setAnswers({
                  ...answers,
                  [answerKey]: opt,
                });
                // Save answer to database
                saveAnswerToDatabase(question, opt, question.correctOption);
              }}
              onCodeSubmit={handleCodeSubmit}
            />
          </div>

          <ExamFooter
            canGoBack={index > 0}
            onBack={() => setIndex(index - 1)}
            onReview={() =>
              setReview({
                ...review,
                [`${section}-${index}`]: true,
              })
            }
            onNext={goNext}
          />
        </div>

        {/* RIGHT – PALETTE */}
        <QuestionPalette
          total={questions.length}
          current={index}
          answers={answers}
          review={review}
          onJump={setIndex}
        />
      </div>
    </ViolationProvider>
  );
}
